import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { L10n, L10nBase } from '@skylab-angular-shared/core';
import { ViewLanguage } from '@skylab-shared/scenes';

@Component({
    selector: 'skl-language-picker-ki',
    templateUrl: './language-picker-ki.component.html',
    styleUrls: ['./language-picker-ki.component.scss']
})
export class LanguagePickerKIComponent {

    public label!: string;

    @Input() public languages: ViewLanguage[] = [];

    @Input() public language!: ViewLanguage;

    @Output() public languageChange = new EventEmitter<ViewLanguage>();

    public constructor(
        @Inject(L10n) private readonly l10n: L10nBase,
    ) {
        this.label = this.l10n._T('language-picker.language');
    }

    public getImageSrc(imageName: string): string {
        return `/assets/images/${imageName}.svg`;
    }

    public onClick(language: ViewLanguage): void {
        this.language = language;
        this.languageChange.emit(this.language);
        (document.querySelector('#ki-panel-change-language-input') as HTMLInputElement).checked = false;
    }
}
